import constants from '#packages/constants';
import type { EditorAPI } from '#packages/editorAPI';
import type { CompRef } from '@wix/document-services-types';

export function isStripOrColumnHasVisibleStyle(
  editorAPI: EditorAPI,
  compRef: CompRef | CompRef[],
) {
  const compType = editorAPI.components.getType(compRef);
  const compStyle = editorAPI.components.style.get(
    Array.isArray(compRef) ? compRef[0] : compRef,
  );
  if (!compStyle || !compType) {
    return false;
  }

  const isDesignedStripOrColumnComp =
    compType === constants.COMP_TYPES.STRIP_COLUMNS_CONTAINER ||
    compType === constants.COMP_TYPES.COLUMN;

  if (!isDesignedStripOrColumnComp) {
    return false;
  }
  const isDesignedSkin =
    compStyle?.skin === constants.SKINS.DESIGNED_COLUMN ||
    compStyle?.skin === constants.SKINS.DESIGNED_STRIP_CONTAINER;

  if (!isDesignedSkin) {
    return false;
  }

  const properties = compStyle.style.properties;
  const parseValues = (value: string) => {
    return value.split(' ').map((v) => parseFloat(v));
  };
  const brwValues = parseValues(properties.brw);
  const rdValues = parseValues(properties.rd);

  const isAnyValueGreaterThanZero = (values: number[]) => {
    return values.some((value) => value > 0);
  };

  if (
    isAnyValueGreaterThanZero(brwValues) ||
    isAnyValueGreaterThanZero(rdValues) ||
    properties['boxShadowToggleOn-shd'] === 'true'
  ) {
    return true;
  }
}

export const isProblematicEffectForDesignedStrip = (effectName: string) => {
  return ['BgParallax', 'BgReveal', 'BgFake3D', 'BgZoomIn'].includes(
    effectName,
  );
};

export const isStripOrColumnHasProblematicScrollEffect = (
  editorAPI: EditorAPI,
  compRef: CompRef,
) => {
  const behaviors: AnyFixMe = editorAPI.components.behaviors.get(compRef);
  const hasBehavior = behaviors.some(
    (behaviors: AnyFixMe) =>
      behaviors?.name && isProblematicEffectForDesignedStrip(behaviors.name),
  );

  return hasBehavior;
};
